export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">关于汗汗漫画</h2>
          <div className="w-16 h-1 bg-primary-500 mx-auto mb-6 rounded-full"></div>
          <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-4 max-w-2xl mx-auto">
            <p>
              汗汗漫画网是一个专注于<strong>韩漫、日漫、国漫</strong>全类型覆盖的在线漫画阅读平台。
              我们致力于为漫画爱好者提供<strong>最流畅的阅读体验</strong>——采用下拉式连续阅读模式，
              告别传统翻页的繁琐操作，让追漫成为一种纯粹的享受。
            </p>
            <p>
              平台收录超过<strong>20000部</strong>漫画资源，涵盖恋爱、热血、悬疑、奇幻、都市、校园等热门分类，
              每日同步更新热门连载，确保漫友第一时间看到最新内容。
              高清画质搭配全球CDN加速，无论手机还是电脑，<strong>在线看漫画流畅不卡顿</strong>。
            </p>
            <p>
              汗汗漫画始终坚持<strong>免费阅读</strong>的理念，所有漫画全集均可免费畅读，
              只为让每一位漫画爱好者都能轻松享受阅读的乐趣。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}